import Action from 'redux/helpers/createAction'
const name = 'admin'

export const getAdminUsers = Action(name + '/GET_USERS', (filters = {}) => ({
  filters
}))
export const getAdminUsersSuccess = Action(name + '/GET_USERS_SUCCESS', (users, meta) => ({
  users,
  meta
}))
export const getAdminUsersFailure = Action(name + '/GET_USERS_FAILURE', error => ({
  error
}))

export const getAdminUserDomains = Action(name + '/GET_DOMAINS', (userId, filters = {}) => ({
  userId,
  filters
}))
export const getAdminUserDomainsSuccess = Action(name + '/GET_DOMAINS_SUCCESS', domains => ({
  domains
}))
export const getAdminUserDomainsFailure = Action(name + '/GET_DOMAINS_FAILURE', error => ({
  error
}))

export const impersonateUser = Action(name + '/IMPERSONATE', userId => ({
  userId
}))
export const impersonateUserFailure = Action(name + '/IMPERSONATE_FAILURE', error => ({
  error
}))
export const switchToAdmin = Action(name + '/SWITCH_TO_ADMIN')
